import PuzzleBox3x3 from "./numberGameComponents/PuzzleBox3x3"
import PuzzleBox3x3hard from "./numberGameComponents/PuzzleBox3x3hard"
import PuzzleBox4x4 from "./numberGameComponents/PuzzleBox4x4"
import PuzzleBox4x4hard from "./numberGameComponents/PuzzleBox4x4hard"
import PuzzleBox5x5 from "./numberGameComponents/PuzzleBox5x5"
import PuzzleBox5x5hard from "./numberGameComponents/PuzzleBox5x5hard"


import MemoryGameLevOne from "./imageGameComponents/MemoryGameLevOne"
import MemoryGameLevTwo from "./imageGameComponents/MemoryGameLevTwo"


import SlidingNumber3x3 from "./numberGameComponents/SlidingNumber3x3"
import SlidingNumber4x4 from "./numberGameComponents/SlidingNumber4x4"


import GameMenu from "./gamepages/GameMenu";
// import About from "./gamepages/About.Js";

import SelectAlphabetsLowerCase from "./alphabetGameComponents/SelectAlphabetsLowerCase"
import SelectAlphabetsUpperCase from "./alphabetGameComponents/SelectAlphabetsUpperCase"

import AlphabetFill from "./alphabetGameComponents/AlphabetFill"
import NumberFill from "./numberGameComponents/NumberFill"


import { BrowserRouter , Routes , Route } from "react-router-dom";





function App() {
  return (
    <div className="App">
      <BrowserRouter>
          <Routes>
            <Route index element={<GameMenu/>} />
            <Route path="/" element={<GameMenu/>} />
            <Route path="/3x3select/normal" element={<PuzzleBox3x3/>} />
            <Route path="/3x3select/hard" element={<PuzzleBox3x3hard/>} />
            <Route path="/4x4select/normal" element={<PuzzleBox4x4/>} />
            <Route path="/4x4select/hard" element={<PuzzleBox4x4hard/>} />
            <Route path="/5x5select/normal" element={<PuzzleBox5x5/>} />
            <Route path="/5x5select/hard" element={<PuzzleBox5x5hard/>} />


            <Route path="/memorygame1" element={<MemoryGameLevOne/>} />
            <Route path="/memorygame2" element={<MemoryGameLevTwo/>} />


            <Route path="/slidingwindow3x3" element={<SlidingNumber3x3/>} />
            <Route path="/slidingwindow4x4" element={<SlidingNumber4x4/>} />
            
            
            <Route path="/selectAlphabetsLowerCase" element={<SelectAlphabetsLowerCase/>} />
            <Route path="/selectAlphabetsUpperCase" element={<SelectAlphabetsUpperCase/>} />

            <Route path="/alphabetFill" element={<AlphabetFill/>} />
            <Route path="/numbersFill" element={<NumberFill/>} />

            
            {/* <Route path="/about" element={<About/>} /> */}
          </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
